<template>
  <div>
    <b-card-text><strong>{{ $t('อัตราการจ่ายรางวัล') }}</strong></b-card-text>
    <b-table
      :tbody-tr-class="lockedRowClass"
      responsive
      bordered
      :fields="$tFields(fields)"
      :items="items"
    >
      <template #cell(type)="data">
        <div class="type-cell">
          {{ $tDisplay(betTypeLabel(data.value, options)) }}
          <feather-icon
            v-if="isLocked(data.value)"
            v-b-tooltip.hover
            :title="$t(huayId === 'yeekee' ? 'fourFiveDigit.lockedYeekee' : 'fourFiveDigit.locked')"
            icon="LockIcon"
            class="type-lock"
          />
        </div>
      </template>
      <template #cell(normal)="data">
        <div @click="editData(data.index,'normal')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip1)="data">
        <div @click="editData(data.index,'vip1')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip2)="data">
        <div @click="editData(data.index,'vip2')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip3)="data">
        <div @click="editData(data.index,'vip3')">
          {{ data.value }}
        </div>
      </template>
      <template #cell(vip4)="data">
        <div @click="editData(data.index,'vip4')">
          {{ data.value }}
        </div>
      </template>
    </b-table>

    <div class="text-right">
      <b-button
        v-if="$can('update', 'lotto.rate')"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="mt-1"
        @click.prevent="saveEdit"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
        />
        <span class="align-middle">{{ $t('Submit') }}</span>
      </b-button>
    </div>

    <b-modal
      v-model="showModal"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('Ok')"
      centered
      size="xs"
      :title="$t('เเก้ไข')"
      button-size="sm"
      @ok="submitEdit"
      @hidden="modalTextError=''"
    >
      <b-form-input
        v-model="modalText"
        autofocus
        type="number"
        @keypress.enter="submitEdit"
      />
      <small
        v-if="modalTextError !== ''"
        class="text-danger"
      >{{ modalTextError }}</small>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable dot-notation */

import {
  BButton, BCardText, BFormInput, BModal, BTable, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import lottoService from '@/service/lottoService'
import { betTypeLabel, isLockedFourFiveDigit } from '@/utils/betTypes'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BTable,
    BButton,
    BModal,
    BFormInput,
    BCardText,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    // 4/5 ตัว: ประเภทที่แก้ได้ (ติ๊กเปิดในหวยนี้แล้ว) · ประเภทใหม่ที่ไม่อยู่ในนี้แสดงอย่างเดียว
    editableTypes: {
      type: Array,
      default: () => [],
    },
    username: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    huayId: {},
    // eslint-disable-next-line vue/require-default-prop,vue/require-prop-types
    huayType: {},
    huayRate: {
      type: Array,
      default: null,
    },
    // เจ้าของลูกค้า — ชื่อผู้ใช้เปล่าระบุตัวลูกค้าไม่ได้เพราะซ้ำกันข้ามสายได้
    ownerAgent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: [
        'สามตัวบน',
        'สามตัวโต้ด',
        'สามตัวหน้า',
        'สามตัวท้าย',
        'สองตัวบน',
        'สองตัวล่าง',
        'วิ่งบน',
        'วิ่งล่าง',
      ],
      fields: [
        {
          key: 'type',
          label: 'ประเภท',
          class: 'text-nowrap text-center',
        },
        {
          key: 'normal',
          label: 'ปกติ',
          class: 'text-center',
        },
        {
          key: 'vip1',
          label: 'vip1',
          class: 'text-center',
        },
        {
          key: 'vip2',
          label: 'vip2',
          class: 'text-center',
        },
        {
          key: 'vip3',
          label: 'vip3',
          class: 'text-center',
        },
        {
          key: 'vip4',
          label: 'vip4',
          class: 'text-center',
        },
      ],
      items: [],
      focusableObj: {
        row: 0,
        key: '',
      },
      showModal: false,
      modalText: '',
      modalTextError: '',
    }
  },
  computed: {
    // ส่งเจ้าของไปกับคำขอเสมอ ไม่งั้นเซิร์ฟเวอร์จะเดาว่าเป็นลูกค้าของผู้เรียกเอง
    ownerQuery() {
      return this.ownerAgent ? `?agent=${encodeURIComponent(this.ownerAgent)}` : ''
    },
  },
  mounted() {
    this.items = this.huayRate
    if (this.huayType === 5) {
      this.options = [
        '4 ตัวตรง',
        '3 ตัวตรง',
        '4 ตัวโต๊ด',
        '3 ตัวโต๊ด',
        // "3 ตัวหน้าตรง",
        '2 ตัวหน้า',
        '2 ตัวหลัง',
      ]
    }
  },
  methods: {
    betTypeLabel,
    isLocked(type) {
      return isLockedFourFiveDigit(type, this.editableTypes)
    },
    lockedRowClass(item) {
      return item && this.isLocked(item.type) ? 'text-muted' : ''
    },
    editData(row, key) {
      if (this.isLocked(this.items[row].type)) return
      this.showModal = true
      this.focusableObj.row = row
      this.focusableObj.key = key
      this.modalText = this.items[row][key]
    },
    submitEdit(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (this.modalText * 1 < 0) {
        this.modalTextError = this.$t('ตัวเลขต้องมีค่าตั้งเเต่ 0 ขึ้นไป')
      } else {
        const { row, key } = this.focusableObj
        this.items[row][key] = this.modalText
        this.showModal = false
      }
    },
    saveEdit() {
      if (this.huayId) {
        this.$swal({
          dark: true,
          title: this.$t('Are you sure?'),
          text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: this.$t('Ok'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(async result => {
          if (result.value) {
            // eslint-disable-next-line no-restricted-syntax
            for (const v of this.huayRate) {
              v.normal *= 1
              // v.inverse *= 1;
              v.vip1 *= 1
              v.vip2 *= 1
              v.vip3 *= 1
              v.vip4 *= 1
            }
            const res = await lottoService.putAuthen(
              `rate-user/reward/${this.huayId}${this.ownerQuery}`,
              this.huayRate,
            )
            if (res.status === 200) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('สำเร็จ'),
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: this.$t('บันทึกข้อมูสำเร็จ'),
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: this.$t('เกิดข้อผิดพลาด'),
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                  text: res.data,
                },
              })
            }
          }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// ไอคอนล็อกวางทับขอบขวาของช่อง ไม่ดันชื่อประเภท แถวที่ล็อกจึงตรงกับแถวอื่น
.type-cell {
  position: relative;
}

.type-lock {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
